import * as Yup from 'yup';
export const CommercialEvaluationValidations = Yup.object().shape({
  //overview: Yup.string().max(255).required('Please fill the technical overview.'),
});
